/* TARZ — Shopping bag dropdown */
(function () {
  const MOCK_CART = {
    item_count: 1,
    total_price: 499900,
    currency: 'PKR',
    items: [{
      id: 1,
      title: 'Sage Leaf Printed Lawn',
      product_title: 'Sage Leaf Printed Lawn',
      url: 'tarz-product-detail.html',
      image: 'https://cdn.shopify.com/s/files/1/0618/4258/7729/files/DSC00960.jpg?v=1776710785',
      quantity: 1,
      price: 499900,
      variant_title: 'M / Sage Green',
      options_with_values: [
        { name: 'Size', value: 'M' },
        { name: 'Colour', value: 'Sage Green' }
      ]
    }]
  };

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents, currency) {
    const amount = Number(cents) / 100;
    const code = currency || 'PKR';
    try {
      return new Intl.NumberFormat('en-PK', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch {
      return code + ' ' + amount.toLocaleString('en-PK');
    }
  }

  function itemCountLabel(n) {
    return n === 1 ? '1 Item(s)' : `${n} Item(s)`;
  }

  function variantLines(item) {
    if (item.options_with_values?.length) {
      return item.options_with_values
        .map(o => `${escapeHtml(o.name)}: <strong>${escapeHtml(o.value)}</strong>`)
        .join(' · ');
    }
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return escapeHtml(item.variant_title);
    }
    return '';
  }

  function renderItem(item) {
    const img = item.image || item.featured_image?.url || '';
    const attrs = variantLines(item);
    return `
      <article class="cart-bag-item">
        <a href="${escapeHtml(item.url)}" class="cart-bag-item-img">
          ${img ? `<img src="${escapeHtml(img)}" alt="" width="72" height="72" loading="lazy">` : ''}
        </a>
        <div class="cart-bag-item-info">
          <a href="${escapeHtml(item.url)}" class="cart-bag-item-title">${escapeHtml(item.product_title || item.title)}</a>
          ${attrs ? `<p class="cart-bag-item-attrs">${attrs}</p>` : ''}
        </div>
        <button type="button" class="cart-bag-item-remove" data-line-key="${escapeHtml(item.key || item.id)}" aria-label="Remove ${escapeHtml(item.product_title || item.title)}">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
        </button>
      </article>`;
  }

  function renderCart(cart, opts) {
    const count = cart.item_count || 0;
    const promo = opts.promo || '';
    const shipping = opts.shipping || '';

    if (!count) {
      return `
        <h2 class="cart-bag-title">Shopping Bag</h2>
        <div class="cart-bag-empty">
          <p>Your bag is empty</p>
          <a href="${escapeHtml(opts.shopUrl || '/')}" class="cart-bag-btn cart-bag-btn--primary">Continue Shopping</a>
        </div>`;
    }

    const itemsHtml = (cart.items || []).map(renderItem).join('');

    return `
      <h2 class="cart-bag-title">Shopping Bag</h2>
      <p class="cart-bag-summary">Item Summary <span>${itemCountLabel(count)}</span></p>
      ${promo ? `<div class="cart-bag-promo">${promo}</div>` : ''}
      ${shipping ? `<p class="cart-bag-shipping">Estimated Shipping: <strong>${escapeHtml(shipping)}</strong></p>` : ''}
      <div class="cart-bag-items">${itemsHtml}</div>
      <div class="cart-bag-footer">
        <div class="cart-bag-total">
          <span>Total</span>
          <strong>${formatMoney(cart.total_price, cart.currency)}</strong>
        </div>
        <a href="${escapeHtml(opts.cartUrl)}" class="cart-bag-btn cart-bag-btn--secondary">View Bag</a>
        <a href="${escapeHtml(opts.checkoutUrl)}" class="cart-bag-btn cart-bag-btn--primary">Checkout</a>
      </div>`;
  }

  function updateBadge(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  async function fetchCart(useMock) {
    if (useMock) {
      await new Promise(r => setTimeout(r, 80));
      return structuredClone(MOCK_CART);
    }
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  function init() {
    const dropdown = document.querySelector('[data-cart-dropdown]');
    const overlay = document.querySelector('[data-cart-overlay]');
    const content = dropdown?.querySelector('[data-cart-content]');
    const loading = dropdown?.querySelector('[data-cart-loading]');
    const toggles = document.querySelectorAll('[data-cart-toggle]');

    if (!dropdown || !content || !toggles.length) return;

    const useMock = dropdown.dataset.mock === 'true';
    const opts = {
      cartUrl: dropdown.dataset.cartUrl || '/cart',
      checkoutUrl: dropdown.dataset.checkoutUrl || '/checkout',
      promo: dropdown.dataset.promo || 'Prepay now & get <strong>FREE delivery</strong> across Pakistan!',
      shipping: dropdown.dataset.shippingDate || '3–5 business days',
      shopUrl: dropdown.dataset.shopUrl || '/'
    };

    let open = false;
    let cachedCart = null;

    function setOpen(next) {
      open = next;
      dropdown.hidden = !open;
      overlay.hidden = !open;
      dropdown.classList.toggle('is-open', open);
      document.body.classList.toggle('cart-bag-open', open);
      toggles.forEach(btn => btn.setAttribute('aria-expanded', open ? 'true' : 'false'));
      if (open) loadCart();
    }

    async function loadCart() {
      loading.hidden = false;
      content.innerHTML = '';
      try {
        cachedCart = await fetchCart(useMock);
        updateBadge(cachedCart.item_count || 0);
        content.innerHTML = renderCart(cachedCart, opts);
      } catch {
        content.innerHTML = '<p class="cart-bag-error">Could not load your bag. Please try again.</p>';
      } finally {
        loading.hidden = true;
      }
    }

    toggles.forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        setOpen(!open);
      });
    });

    overlay?.addEventListener('click', () => setOpen(false));

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && open) setOpen(false);
    });

    document.addEventListener('click', e => {
      if (!open) return;
      if (dropdown.contains(e.target)) return;
      if ([...toggles].some(btn => btn.contains(e.target))) return;
      setOpen(false);
    });

    if (!useMock) {
      loadCart();
    } else {
      updateBadge(MOCK_CART.item_count);
    }

    content.addEventListener('click', async (e) => {
      const removeBtn = e.target.closest('.cart-bag-item-remove');
      if (!removeBtn) return;
      e.preventDefault();
      const key = removeBtn.dataset.lineKey;
      if (!key) return;
      removeBtn.disabled = true;
      removeBtn.style.opacity = '0.3';
      if (useMock) {
        const idx = MOCK_CART.items.findIndex(i => String(i.key || i.id) === key);
        if (idx > -1) {
          MOCK_CART.total_price -= MOCK_CART.items[idx].price * MOCK_CART.items[idx].quantity;
          MOCK_CART.items.splice(idx, 1);
          MOCK_CART.item_count = MOCK_CART.items.length;
        }
        loadCart();
      } else {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          loadCart();
        } catch {
          removeBtn.disabled = false;
          removeBtn.style.opacity = '1';
        }
      }
    });

    document.addEventListener('cart:updated', () => {
      if (open) loadCart();
      else fetchCart(useMock).then(c => updateBadge(c.item_count || 0)).catch(() => {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.TarzCart = { refresh: () => document.dispatchEvent(new CustomEvent('cart:updated')) };
})();
